exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.users-groups {\n  padding: 40px 30px;\n}\ndiv.users-groups table thead {\n  color: #aaa;\n}\ndiv.users-groups table thead th {\n  width: 20%;\n}\ndiv.users-groups table tbody tr {\n  background: #fafafa;\n  cursor: pointer;\n}\ndiv.users-groups table tbody tr td {\n  width: 20%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/groups.component.less
// module id = ../../../../../src/app/dashboard/program-list/program/groups/groups.component.less
// module chunks = 2